import {
  ScrollAreaScrollbar,
  ScrollAreaThumb,
} from '@radix-ui/react-scroll-area'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

export interface ScrollBarProps extends ComponentPropsWithoutRef<
  typeof ScrollAreaScrollbar
> {
  highlight?: boolean
}

export const ScrollBar = forwardRef<
  ElementRef<typeof ScrollAreaScrollbar>,
  ScrollBarProps
>(({ className, orientation = 'vertical', highlight, ...props }, ref) => (
  <ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    className={cn(
      'flex touch-none select-none transition-colors',
      orientation === 'vertical' &&
        'h-full w-2.5 border-l border-l-transparent p-px',
      orientation === 'horizontal' &&
        'h-2.5 flex-col border-t border-t-transparent p-px',
      className
    )}
    {...props}
  >
    <ScrollAreaThumb
      className={cn(
        'relative flex-1 rounded-full bg-active',
        highlight && 'bg-gray-500'
      )}
    />
  </ScrollAreaScrollbar>
))
ScrollBar.displayName = ScrollAreaScrollbar.displayName
